import { IJsonQuery } from '@cian/api-models/common/json_query';
import * as R from 'ramda';

import { NonEmptyArray } from './types/common';
import { EFacilityType } from './types';
import { resetTerms, setTerm } from './helpers';

export function setLivingConditions(jsonQuery: IJsonQuery) {
  return (facilityTypes: NonEmptyArray<EFacilityType> | null): IJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    nextJsonQuery = resetTerms(['kids', 'pets'])(nextJsonQuery);

    if (facilityTypes) {
      if (facilityTypes.includes(EFacilityType.KidsAllowed)) {
        nextJsonQuery = setTerm('kids')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.PetsAllowed)) {
        nextJsonQuery = setTerm('pets')(nextJsonQuery)(true);
      }
    }

    return nextJsonQuery;
  };
}
